var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFaraonaBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.17 24.13C37.7 23.66 39.68 23.28 42.29 23.44C43.57 23.52 44.28 21.96 43.34 21.09C41.07 18.96 38.57 17.8 35.14 17.22",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.78 47.44C28.14 41.31 26.2 32.62 27.32 29.05C27.45 28.62 29.03 26.56 29.72 25.76",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.31 12.03C34.77 11.92 34.17 15.86 34.17 20.14C34.17 23.62 34.41 27.12 34.71 29.4C34.91 30.88 31.17 28.05 29.93 25.51C28.25 22.06 31.2 15.35 29.49 13.11C27.06 9.93001 16.55 7.56001 10.85 12.58C4.66004 18.03 5.54004 28.17 8.50004 33.32C9.57004 35.18 10.28 37.87 10.51 40.57",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.17 10.13C16.2 8.56998 14.42 1.25998 18.6 2.75998C21.78 3.89998 24.17 7.12998 24.17 7.12998",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFaraonaBlack);
export default __webpack_public_path__ + "static/media/ic_faraona_black.5d851a1506f8886c9525d1b0d96ce2bd.svg";
export { ForwardRef as ReactComponent };